import * as yup from 'yup';

export const activationValidations = yup.object().shape({
  deactivatedEstablishmentTerms: yup
    .bool()
    .oneOf([true], 'É necessário aceitar os termos para continuar')
});